<template>
    <div class="order-detail-section mg20" v-if="reason">
        <h3>修订理由：</h3>
        <div style="padding: 4px 24px">{{reason}}</div>
    </div>
</template>

<script>
    export default {
        name: "order_reason",
        props: {
            reason: {
                required:false
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/partial/order_reason.vue